import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useContent } from '../../content/ContentProvider';
import { isPrerenderCrawl } from '../../utils/isPrerenderCrawl';

/**
 * Marks the document ready for react-snap after route content + Helmet settle.
 * Always sets the attribute (harmless for users) so snap waitFor is reliable
 * even if the Puppeteer UA string differs across environments.
 */
export default function PrerenderReady() {
  const location = useLocation();
  const { ready } = useContent();

  useEffect(() => {
    document.documentElement.removeAttribute('data-prerender-ready');

    let cancelled = false;
    const markReady = () => {
      if (cancelled) return;
      document.documentElement.setAttribute('data-prerender-ready', '1');
      if (isPrerenderCrawl()) {
        document.documentElement.classList.add('app-hydrated');
        const boot = document.getElementById('app-boot');
        if (boot) boot.classList.add('is-hidden');
      }
    };

    const delayMs = ready ? 500 : 1200;
    const timer = window.setTimeout(markReady, delayMs);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [location.pathname, location.search, ready]);

  return null;
}
